import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../css/RemoteAccess.css'; // Import CSS

const RemoteAccessForm = () => {
  const navigate = useNavigate();
  
  // State Management
  const [okasBoxData, setOkasBoxData] = useState([]);
  const [selectedProject, setSelectedProject] = useState('');
  const [selectedDuration, setSelectedDuration] = useState('');
  const [selectedReason, setSelectedReason] = useState('');
  const [description, setDescription] = useState('');
  const [checkuserApidata, setCheckuserApidata] = useState({});
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  // Static Options
  const durationOptions = [
    { label: '2 Hour', value: '2' },
    { label: '5 Hours', value: '5' },
    { label: '12 Hours', value: '12' },
    { label: '24 Hours', value: '24' },
    { label: '48 Hours', value: '48' },
  ];

  const reasonOptions = [
    { label: 'Support', value: 'Support' },
    { label: 'Programming', value: 'Programming' },
    { label: 'Maintenance', value: 'Maintenance' },
  ];

  // Fetch User Data
  const checkuserApi = () => {
    const token = `Token ${localStorage.getItem('auth')}`;
    fetch('/we/we/userCheckApi/', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: token },
    })
      .then((response) => response.json())
      .then((data) => setCheckuserApidata(data))
      .catch((error) => console.error('Error fetching user data:', error));
  };

  // Fetch Projects
  const fetchProjects = () => {
    const token = `Token ${localStorage.getItem('auth')}`;
    fetch('/we/get-all-projects/', {
      method: 'GET',
      headers: { Authorization: token, 'Content-Type': 'application/json' },
    })
      .then((response) => {
        if (!response.ok) throw new Error('Failed to fetch projects');
        return response.json();
      })
      .then((data) => setOkasBoxData(data))
      .catch((error) => console.error('Error fetching projects:', error));
  };

  // Handle Input Changes
  const handleChange = (setter) => (event) => {
    setter(event.target.value);
    setErrors((prevErrors) => ({ ...prevErrors, [event.target.name]: '' }));
  };

  // Submit Form
  const Access = () => {
    const token = `Token ${localStorage.getItem('auth')}`;
    const csrfToken = document.cookie.split('; ').find((row) => row.startsWith('csrftoken='))?.split('=')[1];

    const validationErrors = {};
    if (!selectedProject) validationErrors.selectedProject = 'Project Name is required';
    if (!selectedDuration) validationErrors.selectedDuration = 'Duration is required';
    if (!selectedReason) validationErrors.selectedReason = 'Reason is required';
    if (!description) validationErrors.description = 'Description is required';

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const payload = {
      project_building: selectedProject,
      ticket_type: 'remote_access',
      duration: selectedDuration,
      reason: selectedReason,
      issue_description: description,
      created_by: checkuserApidata.user_name,
      name: checkuserApidata.first_name,
      remote_access: true,
    };

    setLoading(true);

    fetch('/we/supportticket/', {
      method: 'POST',
      headers: { Authorization: token, 'Content-Type': 'application/json', 'X-CSRFToken': csrfToken },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then(() => {
        setTimeout(() => {
          const nextPath = window.location.pathname === '/remote-access2' ? '/approve2' : '/approve';
          navigate(nextPath);
    
          setTimeout(() => {
            navigate(nextPath === '/approve2' ? '/support2' : '/support');
          }, 5000);
        }, 200);
      })
      .catch((error) => console.error('Error submitting request:', error))
      .finally(() => setLoading(false));
    }

  // Fetch Data on Mount
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setSelectedProject(params.get('project') || '');
    
    fetchProjects();
    checkuserApi();
  }, []);

  return (
    <div className="Supportcontainer">
      <h1 className="title">Request for Remote Access of Design Studio</h1>
      <p className="description">
        You can access the design studio for a limited time. This request will be<br />
        recorded and shared with the client as well as the OKAS support team.
      </p>

      <form className="form">
        <div className="form-left">
          {/* Project Name */}
          <div className="form-group">
            <label>Project Name</label>
            <select name="selectedProject" className="dropdown" value={selectedProject} onChange={handleChange(setSelectedProject)}>
              <option value="">Select Project</option>
              {okasBoxData.map((project) => (
                <option key={project.building_id} value={project.building_id}>
                  {project.building_name}
                </option>
              ))}
            </select>
            {errors.selectedProject && <p className="error-message">{errors.selectedProject}</p>}
          </div>

          {/* Duration */}
          <div className="form-group">
            <label>Duration</label>
            <select name="selectedDuration" className="dropdown" value={selectedDuration} onChange={handleChange(setSelectedDuration)}>
              <option value="">Select Duration</option>
              {durationOptions.map((option) => (
                <option key={option.value} value={option.value}>{option.label}</option>
              ))}
            </select>
            {errors.selectedDuration && <p className="error-message">{errors.selectedDuration}</p>}
          </div>

          {/* Reason */}
          <div className="form-group">
            <label>Reason</label>
            <select name="selectedReason" className="dropdown" value={selectedReason} onChange={handleChange(setSelectedReason)}>
              <option value="">Select Reason</option>
              {reasonOptions.map((option) => (
                <option key={option.value} value={option.value}>{option.label}</option>
              ))}
            </select>
            {errors.selectedReason && <p className="error-message">{errors.selectedReason}</p>}
          </div>

          {/* Description */}
          <div className="form-group">
            <label>Description</label>
            <textarea name="description" className="textarea" rows="4" value={description} onChange={handleChange(setDescription)} placeholder="Enter description..."></textarea>
            {errors.description && <p className="error-message">{errors.description}</p>}
          </div>

          {/* Submit Button */}
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <button
              className="submit-button"
              type="button"
              onClick={Access}
              disabled={loading}
            >
              {loading ? "Submitting..." : "Access"}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default RemoteAccessForm;

